import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { selectCurrentPage } from "context/pages/pageSlice";
import { useGetDistributersQuery } from "context/distributer/distributerApiSlice"; // useUpdateDistributDistributorMutation
import { useMaterialUIController } from "context";
import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

import CssBaseline from '@mui/material/CssBaseline';
import { Grid, Card, Divider, Tabs, Tab, Paper} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

import MDAvatar from "dashboard/components/MDAvatar";

import Navigation  from "components/Home/components/navigation";
import LandingFooter from "components/Home/components/landingFooter";
import DistributorCard from "components/Home/distributers/sections/components/Distributor"
import Products from "components/Home/products/sections/Products";

import loader from "assets/images/shapes/loader.svg";
import bgImage from "assets/images/bg-reset-cover.jpeg";


const parseContent = content => parse(DOMPurify?.sanitize(content));

const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}

const Distributor = () => {
  const [controller ] = useMaterialUIController();
  const pageContent = useSelector(selectCurrentPage);
  const { lang } = controller;
  const { id } = useParams();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  const { distributer, isLoading } = useGetDistributersQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => {
      const Distributors = data?.entities ? Object.values(data?.entities) : [];
      // Return the selected Distributor and isLoading state
      return {
        distributer: Distributors instanceof Array ? Distributors.find((prod) => prod.id === Number(id)) : null,
        isLoading, // Include isLoading
      };
    },
    skip: !id, // Skip the query if no DistributorId is provided
  });

  return (
    <>
      <MDBox
        minHeight={{xs:"20vh" , lg: "40vh"}}
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          marginTop : pageContent.Menu ? "225px" : "150px"
        }}
      />
       {pageContent.Navigation?.navBar && <Navigation parseContent={parseContent} data={{ navBar : pageContent.Navigation?.navBar, logo : pageContent.Navigation.logo?.selectedImage,  menu: pageContent.Menu }}  />}
      <Card
        sx={{
          p: { xs: 1, lg: 2 },
          mx: { xs: .5, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.header, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Paper sx={{p:1, borderRadius : 2}}>
          <Grid container alignItems="center">
            <Grid item xs={12} lg={2.5}>
              {distributer && tabIndex !== 0 ? 
              <MDTypography variant="h5" fontWeight="medium" color="primary" textTransform="capitalize">
                {distributer.companyName === "" || !distributer.companyName ? distributer.displayName : `${distributer.raisonSociale !== "" ? 
                distributer.raisonSociale : ""} ${distributer.companyName}`} 
              </MDTypography> : null}
            </Grid>
            <Grid item xs={12} lg={4}>       
                <Tabs value={tabIndex} onChange={handleTabChange} centered>
                  <Tab label="a propos" />
                  <Tab label="Nos produit" />
                </Tabs>
            </Grid>
          </Grid>
        </Paper>
        <MDBox >
          <CssBaseline />
          {tabIndex === 0 ? (<Grid container sx={{mt:{xs:0,lg:1}}} spacing={2} >
            <Grid item xs={12} lg={6}>
            {distributer && (<DistributorCard distributer={distributer} parseContent={parseContent} />)}
            </Grid>
            <Grid item xs={12} lg={6}>
            {distributer && (<Card sx={{p:{xs:1,lg:2}}}>
               <MDTypography variant="h3" fontWeight="medium" color="info" textTransform="capitalize">
                        à propos de {distributer.companyName === "" || !distributer.companyName ? distributer.displayName : `${distributer.raisonSociale !== "" ? distributer.raisonSociale : "" } ${distributer.companyName}`}
                </MDTypography>
                <MDTypography my={.5} variant="body2" color="text" fontWeight="regular">
                  {parseContent(distributer.description)}
                </MDTypography>
              </Card>)}
            </Grid>
          </Grid>) :(
              <Products parseContent={parseContent} distributerId={distributer.id} />
          )}
        </MDBox>
        {isLoading && ( <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
          src={loader} alt="Avatar" variant="square" size="md" />
        )}
      </Card>
      {pageContent.Contact && <LandingFooter data={pageContent.Contact} feed={pageContent.Features} limitTextToWords={limitTextToWords} about={pageContent.About} navBar={pageContent.Navigation?.navBar} logo={pageContent.Navigation.logo?.selectedImage} parseContent={parseContent}/>}
    </>
  )
}

export default Distributor